import { render, staticRenderFns } from "./EditReturnModal.vue?vue&type=template&id=ad35a460"
import script from "./EditReturnModal.vue?vue&type=script&lang=js"
export * from "./EditReturnModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports